export class OrderPaymentCheckCreation {
  constructor(data) {
    this.checkName = data.checkName;
    this.checkNumber = data.checkNumber;
    this.amount = data.amount;
  }
}
